import React,{useState,useEffect, useRef} from "react";
import './classes/CreateNewDiscount.css';
import { configData } from "../config";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import Select from 'react-dropdown-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
 import { format } from "date-fns";
import { Link, useNavigate,useLocation,useParams  } from 'react-router-dom';
import SalespersonSidebar from "./SalespersonSidebar";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';



const CreateNewDiscount = () => {
    
    const [isLoading, setIsLoading] = useState(true);    
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    var {uid} = useParams();
    var {username} = useParams();
    if(location.state) {
    uid = location.state;
    }
    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    useEffect(() => {
        setIsLoading(true);
    
        const timer = setTimeout(() => {
        setIsLoading(false);
        }, 1000); //  minimum 1 second spinner
    
        return () => clearTimeout(timer);
    }, []);
  const initialForm = {
  discount_switch: '1',
  country: '',
  discount_name: '',
  machine_name: '',
  isEditing: false,
  hasCustomMachineName: false,
  start_date: '',
  start_date_obj: null,
  end_date: '',
  end_date_obj: null,
  offer_type: '',
  fixed_price: '',
  per_price: '',
  product_type: '',
  selected_plist: [],
  discount_status: '1',
  neww_coupon: '',
  existing_coupon: ''
};

      const startDateRef = useRef(null);
      const endDateRef = useRef(null);
      const [formData, setFormData] = useState(initialForm);
      const [discountType, setDiscountType] = useState("1");
      const [errors, setErrors] = useState([]);  
      const [formErrors, setFormErrors] =useState({});     
      const[success,setSuccess] = useState('');
      const [fieldErrors, setFieldErrors] = useState({});
      const [countriesList, setCountriesList] = useState([]);
      const [selectedcountry, setSelectedCountry] = useState([]);
      const [offerType, setOfferType] = useState("0"); // "0" = $ off, "1" = % off
      const [fixedPrice, setFixedPrice] = useState("");
      const [percentage, setPercentage] = useState("");
      const [productCategories, setProductCategories] = useState([]);

      const [searchValue, setSearchValue] = useState('');
      const [options, setOptions] = useState([]);
      
       const [selectedCoupon, setSelectedCoupon] = useState(null);
        //  const [allAthletes, setAthleteList] = useState([]);
          const [allCoupons, setCouponList] = useState([]);
         useEffect(() => {
              
          // Implement debouncing here if needed
          const fetchData = async () => {
              if (searchValue.trim() === '') {
              setOptions([]); // Clear options if search is empty
              return;
              }
              try {
              // Replace with your actual API call
              const response = await fetch(app_url+'smwwcommercecoupon/getcouponlist?query='+searchValue);
              const data = await response.json();
              setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
              } catch (error) {
              console.error('Error fetching data:', error);
              }
          };
      
          const handler = setTimeout(() => {
              fetchData();
          }, 500); // Debounce for 500ms
      
          return () => {
              clearTimeout(handler);
          };
          }, [searchValue]);
              const renderOption = (props, option) => (
    <li {...props}>
        {option.label}
    </li>
    );

    const getOptionLabel = (option) => option?.label || '';

    const onChange = (event, newValue) => {
        console.log('Selected coupon:', newValue);
        setSelectedCoupon(newValue);
       
        setSearchValue(newValue ? newValue.label : ''); 
        setFormData(prev => ({
            ...prev,
            existing_coupon: newValue ? newValue.id : '',
        }));
    };

const [tempMachineName, setTempMachineName] = useState("");

     useEffect(() => {
         Promise.all([
          getathletelist(),
            retrieveCountriesList(),
            retrieveProductCategories(),
          ])
          .then(() => {
          
           setIsLoading(false);
         })
     }, []);
 useEffect(() => {
  if (discountType === "1") {
    // Switched TO Country Discount
    setFormData((prev) => ({
      ...prev,
      machine_name: "",
      country: "",           //  clear the selected country in formData
      isEditing: false,
    }));
    setSelectedCountry([]);   // clear Select component value (since it's an array)
  } else if (discountType === "2") {
    // Switched TO Product Discount
    setFormData((prev) => ({
      ...prev,
      country: "",            //  also clear here for consistency
      machine_name: "",
      isEditing: false,
    }));
    setSelectedCountry([]);
  }
}, [discountType]);


         async function getathletelist() {
   
         try {
            const response = await fetch(
                app_url+'report/getsalespersonactivity',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCouponList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
         async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result); 
     }
async function retrieveProductCategories() {
    const response = await fetch(
      app_url+'smwwcommercediscount/getproductcategories',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json();

    setProductCategories(data.data.result); 
     }
      const validateForm = () => {

  const newMessages = [];

if (formData.discount_switch === "1") {
    if (!formData.country) newMessages.push("Country is required.");
  }
if (formData.discount_switch === "2" || formData.discount_switch === "3") {
  if (!formData.discount_name) {
    newMessages.push("Discount Name is required.");
  }
}
if (formData.discount_name) {
  if (formData.discount_name.length > 100) {
      newMessages.push("Discount Name should not exceed 100 characters.");
    }
}

  // Offer type validation
  if (offerType === "0" && !fixedPrice) {
    newMessages.push("Fixed Amount is required.");
  }
  if (offerType === "1" && !percentage) {
    newMessages.push("Percentage is required.");
  }

  if (!formData.discount_status) {
    newMessages.push("Discount Status is required.");
  }





  setErrors(newMessages);         
  return newMessages.length === 0;
     
};
// const handleDateChange = (date) => {
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//            setFormData(prev => ({ ...prev, start_date: formattedDate }));
//          };
//       const handleEndDateChange = (date) => {
       
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//             setFormData(prev => ({ ...prev, end_date: formattedDate }));
//       };
  const handleDateChange = (date, field) => {
    setFormData(prev => ({
      ...prev,
      [`${field}_obj`]: date,                   
      [field]: date ? format(date, 'yyyy-MM-dd') : '' 
    }));
  };
      
    const validateDates = (formData) => {
    let errors = {};

  

    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }

    return errors;
  };
  

  const [rows, setRows] = useState([
    { id: 1, productType: "", selectedProducts: [] },
  ]);

  const handleAddRow = () => {
    const newId = rows.length ? rows[rows.length - 1].id + 1 : 1;
    setRows([...rows, { id: newId, productType: "", selectedProducts: [] }]);
  };

  const handleRemoveRow = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleProductTypeChange = (id, value) => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === id
          ? { ...row, productType: value, selectedProducts: [] }
          : row
      )
    );
  };

  const handleSelectedProductsChange = (id, options) => {
    const selected = Array.from(options)
      .filter((opt) => opt.selected)
      .map((opt) => opt.value);
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, selectedProducts: selected } : row))
    );
  };
  const couponsList = [
  "adam25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jeff25",
  "jon25",
  "jon25", 
  "jon25",
  "jon25",   
  "jon25",
  "jon25",
  "jon25",
  "jon25",
  "robert25",
  "INDIA",
]; 
  const [showNew, setShowNew] = useState(false); // toggle between new/existing
  const [showExist, setShowExist] = useState(false);
  const [existingInput, setExistingInput] = useState("");
  const [filteredCoupons, setFilteredCoupons] = useState([]);

  const handleExistingInput = (e) => {
    const value = e.target.value;
    setExistingInput(value);

    const filtered = couponsList.filter((coupon) =>
      coupon.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCoupons(filtered);
  };
const handleCountryChange = (val) => {
  if (!val || val.length === 0) {
    setSelectedCountry([]);
    setFormData((prev) => ({
      ...prev,
      country: "",
      machine_name: "",
      isEditing: false,
      hasCustomMachineName: false,
    }));
    setTempMachineName("");
    return;
  }

  const countryLabel = val[0].label;
  const countryValue = val[0].value;
  const machineName = "discount_country_" + countryLabel.toLowerCase().replace(/\s+/g, "_");

  // Update selected country
  setSelectedCountry(val);

  // Always sync real machine_name to selected country
  setFormData((prev) => ({
    ...prev,
    country: countryValue,
    machine_name: machineName,
  }));

  // Reset editable field to selected country's name
  setTempMachineName(machineName.replace("discount_country_", ""));
};




const handleChange = (e) => {
  const { name, value } = e.target;

 
  if (name === "country") {
    setSelectedCountry([]);
  }

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
  
  if (name === "discount_switch") {
    if (value == 2) {
        setFormData((prev) => ({
            ...initialForm,    
            discount_switch: prev.discount_switch,
        }));
        setSearchValue(''); 
        setSelectedCoupon(null);
        setRows([{ id: 1, productType: "", selectedProducts: [] }]);
        setFixedPrice('');
        setPercentage('');
    }
    if(value == 1 || value == 3) {
        setFormData((prev) => ({
            ...initialForm,    
            discount_switch: prev.discount_switch,
        }));
        setSearchValue(''); 
        setSelectedCoupon(null);
        setRows([
            { id: 1, productType: "", selectedProducts: [] },
        ]);
        setFixedPrice('');
        setPercentage('');
    }
    setDiscountType(value);  
  }
};

 const handleSubmit = async (e) => {
  e.preventDefault();   

  
   const mergedFormData = {
    ...formData,
    offer_type: offerType,
    fixed_price: fixedPrice,
    per_price: percentage,
    existing_coupon: formData.existing_coupon,    
    product_type: rows.map(row => row.productType),
    selected_plist: rows.map(row => row.selectedProducts),
       machine_name: formData.isEditing
      ? "discount_" + tempMachineName
      : formData.machine_name,
  };
    const errors = validateDates(mergedFormData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
     if(validateForm()) {
       try {
            setIsLoading(true);
            const response = await fetch(app_url+'smwwcommercediscount/adddiscountdetails', {
            method: 'POST',
            body: JSON.stringify(mergedFormData),
            headers: {
                'Content-Type': 'application/json',
             },
            });
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setSuccess(responsedata.data.result);
                // setFormData(initialForm);
                setFormData((prev) => ({
                    ...initialForm,       
                    discount_switch: prev.discount_switch || 1, 
                }));
                setSearchValue(''); 
                setSelectedCoupon(null);
                setRows([
                    { id: 1, productType: "", selectedProducts: [] },
                ]);
                setFixedPrice('');
                setPercentage('');
            }
             if(responsedata.data.msg === "Error") {
                setErrors(responsedata.data.result);
            }
         }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
      console.log("Form Submitted Successfully!",mergedFormData);
      //alert("Check console for submitted values.");
      
    } else {
      window.scrollTo(0, 0);
    }
    
  //if (validateForm()) {
    // const response = await fetch(app_url+'user/adduser', {
    //   method: 'POST',
    //   body: JSON.stringify(formData),
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   });
    //  const data = await response.json();
    //    if(data.data.result === "user_created") {
    //      alert('User added successfully!');
    //      setSuccess(data.data.msg);
    //       setFormData(initialForm);
    //       setPassword('');
    //      window.scrollTo(0, 0);
    //    }
    //    else if(data.data.result === "error") {
    //     setErrors(data.data.msg);
    //     window.scrollTo(0, 0);
    //    }

 // }
  // else {
      
   //   window.scrollTo(0, 0);
   // }
   console.log("create new discount submitted formdata",mergedFormData);
};
    return(
          <>
                    {isLoading ? (
                        <Loading />
                    ) : (
                <div id="main">
                     <Helmet>
                        <title>
                            Create Discount
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                      <h1>Create Discount</h1>
                        <div className="create-discount-container">
                        {errors.length > 0 && (
                          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 8px no-repeat`}}>
                          {errors.map((item, index) => {
                          return <>{item}<br /></>
                          
                        })}  
                          </div>
                        )}
                        {success && errors.length === 0 && (
                          <div className="set-message-done">
                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
                          </div>
                          
                      
                        )}
                            <form onSubmit={handleSubmit}>
                                 <div>
                                    <label>
                                        Discount Switch <span className="form-required">*</span>
                                    </label>
                                    <select
                                        id="discount_switch"
                                        name="discount_switch"
                                        value={formData.discount_switch}
                                        onChange={handleChange}
                                    >
                                        <option value="1">Country Discount</option>
                                        <option value="2">Product Discount</option>
                                        <option value="3">Referral Discount</option>        
                                    </select>
                                </div>
                                {discountType === "1" &&(
                                 <div className="country-form-item">
                          <label htmlFor="country">Country</label>
                        
                            <Select 
                             
                             id="country" name="country" className='select-country smww-appn form-text'
                             searchable={true}
                             
                             clearable={true} 
                             clearOnBlur={true} 
                            // clearOnSelect={false}
                             backspaceDelete={true} 
                             
                             style={{backgroundColor:'#ffffff', width:'87.8%',height:'20px', borderRadius: 5}}
                                                
                             options={countriesList} 
                             
                            //  onChange={(val) => {
                            //    if(val.length == 0) {
                            //      console.log(val);
                            //    }
                            //    else{
                            //      console.log(val);
                            //      setSelectedCountry(val);
                            //    handleChange(
                            //      { target: { value: val[0]['value'], name: 'country' } }
                            //    )
                            //    const value = val[0]['label'];
                            // const machineName = "discount_country_" + value.toLowerCase().replace(/\s+/g, "_");

                            // // Always update discount_name
                            // setFormData((prev) => ({
                            //   ...prev,
                            //    discount_name: value,
                            //   machine_name: !prev.hasCustomMachineName ? machineName : prev.machine_name,
                            // }));

                            // // Only update tempMachineName if not manually edited
                            // if (!formData.hasCustomMachineName) {
                            //   setTempMachineName(machineName.replace("discount_country_", ""));
                            // }
                            //    }}
                            //  }
                          onChange={handleCountryChange}
                             values={selectedcountry}                             
                             />
                             &nbsp;&nbsp;
                            {formData.country && (
                        <span className="machine_readable">
                          Machine name: {formData.machine_name}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();

                              // If already editing, don't reset tempMachineName
                              setFormData((prev) => ({
                                ...prev,
                                isEditing: true,
                              }));

                              // Only set tempMachineName the *first time* edit is clicked
                              setTempMachineName((prev) => {
                                if (prev === "" || prev === formData.machine_name.replace("discount_country_", "")) {
                                  return formData.machine_name.replace("discount_country_", "");
                                }
                                return prev; // keep user’s typed value
                              });
                            }}
                            className="admin_edit"
                          >
                            [edit]
                          </a>
                        </span>
                      )}

                      {formData.isEditing && formData.country && (
                        <div className="machine_readable_name" style={{ marginTop: "10px" }}>
                          <label>
                            Machine-readable name <span className="form-required">*</span>
                          </label>
                          discount_country_
                          <input
                            type="text"
                            maxLength={50}
                            value={tempMachineName}
                            onChange={(e) => {
                              // Let user type anything (doesn't affect real machine name)
                              setTempMachineName(e.target.value);
                            }}
                          />
                        </div>
                      )}
                           </div>
                              )}
                                 {(discountType === "2" || discountType === "3") && (
                            
                           <div>
                           {/* <div style={{ marginBottom: "20px" }}>
                          <div className="product_discount" style={{ display: "block" }}>
                            <label>
                              Discount Name <span className="form-required">*</span>
                            </label>
                            <input
                              style={{ width: "30%" }}
                              type="text"
                              className="form-text"
                              name="discount_name"
                              value={formData.discount_name}
                             
                              onChange={(e) => {
                            const value = e.target.value;
                            const machineName = "discount_" + value.toLowerCase().replace(/\s+/g, "_");

                            // Always update discount_name
                            setFormData((prev) => ({
                              ...prev,
                              discount_name: value,
                              // Only update machine_name if not manually edited
                              machine_name: !prev.hasCustomMachineName ? machineName : prev.machine_name,
                            }));

                            // Only update tempMachineName if not manually edited
                            if (!formData.hasCustomMachineName) {
                              setTempMachineName(machineName.replace("discount_", ""));
                            }
                          }}

                                 
                            />
                            &nbsp;&nbsp;
                            {formData.discount_name && (
                              <span className="machine_readable">
                                Machine name: {formData.machine_name}
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setFormData((prev) => ({ ...prev, isEditing: true }));
                                    setTempMachineName(formData.machine_name.replace("discount_", ""));
                                  }}
                                  className="admin_edit"
                                >
                                 
                                  [edit]
                                </a>
                              </span>    

                            )}
                          </div>

                          {formData.isEditing && (
                            <div className="machine_readable_name">
                              <label>
                                Machine-readable name <span className="form-required">*</span>
                              </label>
                              discount_
                               <input
                                type="text"
                               // value={formData.machine_name.replace("discount_", "")}
                                value={tempMachineName}
                                // onChange={(e) => {
                                //   const value = e.target.value;
                                //   setFormData((prev) => ({
                                //     ...prev,
                                //     machine_name: "discount_" + value,
                                //     hasCustomMachineName: true,
                                //   }));
                                // }}
                                onChange={(e) => {
                                  setTempMachineName(e.target.value); // Does not affect formData.machine_name
                                }}
                               // onBlur={saveMachineName}
                              />
                            </div>
                          )}
                        </div> */}
                                <div style={{ marginBottom: "20px" }}>
                                  <div className="product_discount" style={{ display: "block" }}>
                                    <label>
                                      Discount Name <span className="form-required">*</span>
                                    </label>

                                    <input
                                      style={{ width: "30%" }}
                                      autoComplete="off"
                                      type="text"
                                      className="form-text"
                                      name="discount_name"
                                      value={formData.discount_name}
                                      maxLength={50}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const machineName =
                                          "discount_" + value.toLowerCase().replace(/\s+/g, "_");

                                        // Always update discount_name
                                        setFormData((prev) => ({
                                          ...prev,
                                          discount_name: value,
                                          // Only update machine_name if not manually edited
                                          machine_name: !prev.hasCustomMachineName
                                            ? machineName
                                            : prev.machine_name,
                                        }));

                                        // Only update tempMachineName if not manually edited
                                        if (!formData.hasCustomMachineName) {
                                          setTempMachineName(machineName.replace("discount_", ""));
                                        }
                                      }}
                                    />

                                    &nbsp;&nbsp;

                                    {formData.discount_name && (
                                      <span className="machine_readable">
                                        Machine name: {formData.machine_name}
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            // Only set editing to true; no reset of tempMachineName
                                            setFormData((prev) => ({ ...prev, isEditing: true }));

                                            // Only initialize tempMachineName once (don’t overwrite typed text)
                                            setTempMachineName((prev) => {
                                              if (
                                                prev === "" ||
                                                prev === formData.machine_name.replace("discount_", "")
                                              ) {
                                                return formData.machine_name.replace("discount_", "");
                                              }
                                              return prev; 
                                            });
                                          }}
                                          className="admin_edit"
                                        >
                                          [edit]
                                        </a>
                                      </span>
                                    )}
                                  </div>

                                  {/* Editable machine name field */}
                                  {formData.isEditing && (
                                    <div className="machine_readable_name">
                                      <label>
                                        Machine-readable name <span className="form-required">*</span>
                                      </label>
                                      discount_
                                      <input
                                        type="text"
                                        value={tempMachineName}
                                        maxLength={50}
                                        onChange={(e) => {
                                          setTempMachineName(e.target.value);
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>


                          </div>
                          )}
                            <div className=''>
                                <label htmlFor="start_date">Start Date:</label>
                                <DatePicker
                                ref={startDateRef}
                                // selected={formData.start_date}    
                                selected={formData.start_date_obj}                            
                                id="start_date"
                                name="start_date" 
                                // onChange={handleDateChange}
                                onChange={(date) => {
                                  handleDateChange(date, "start_date");
                                  setTimeout(() => {
                                      const input = startDateRef.current?.input;
                                      if (input) {
                                      const len = input.value.length;
                                      input.setSelectionRange(len, len);
                                      }
                                  }, 0);
                                }}
                                className=""
                                />   
                              {formErrors.start_date && (
                                <div className="error">{formErrors.start_date}</div>
                              )}                 
                            </div>
                            <div className=''>
                                <label htmlFor="end_date">End Date:</label>
                                <DatePicker
                                ref={endDateRef}
                                // selected={formData.end_date}
                                selected={formData.end_date_obj}
                                // onChange={handleEndDateChange}
                                onChange={(date) => {
                                  handleDateChange(date, "end_date");
                                  setTimeout(() => {
                                      const input = endDateRef.current?.input;
                                      if (input) {
                                      const len = input.value.length;
                                      input.setSelectionRange(len, len);
                                      }
                                  }, 0);
                                }}
                                id="end_date"
                                name="end_date"
                                className=""
                                />  
                              {formErrors.end_date && (
                                <div className="error">{formErrors.end_date}</div>
                              )}                 
                            </div>
                            <div>
                            <label>Choose Offer Type <span class="form-required">*</span></label>
                              <table className="offer-type-table">
                              <tbody>
                                <tr>
                                  <td>
                                    <label>
                                      <input
                                        type="radio"
                                        className="offer_type"
                                        name="offer_type"
                                        value="0"
                                        checked={offerType === "0"}
                                        onChange={(e) => {setOfferType(e.target.value); setPercentage("");}}
                                      />
                                      $ off
                                    </label>
                                    <br />
                                    <label>
                                      <input
                                        type="radio"
                                        className="offer_type"
                                        name="offer_type"
                                        value="1"
                                        checked={offerType === "1"}
                                        onChange={(e) => {setOfferType(e.target.value); setFixedPrice("");}}
                                      />
                                      % off
                                    </label>
                                  </td>

                                  <td>
                                    {/* Fixed Price field */}
                                    {offerType === "0" && (
                                      <div className="fixed_price">
                                        <label>
                                          Fixed Amount <span className="form-required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-text"
                                          name="fixed_price"
                                          id="fixed_price"
                                          value={fixedPrice}
                                          onChange={(e) => setFixedPrice(e.target.value)}
                                        />{" "}
                                        USD
                                      </div>
                                    )}

                                    {/* Percentage field */}
                                    {offerType === "1" && (
                                      <div className="percentage_price">
                                        <label>
                                          Percentage <span className="form-required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-text"
                                          name="per_price"
                                          id="percentage_price"
                                          value={percentage}
                                          onChange={(e) => setPercentage(e.target.value)}
                                        />{" "}
                                        %
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                              {/* {errors.includes("Fixed Amount is required.") && offerType === "0" && (
    <div className="error">Fixed Amount is required.</div>
  )}
  {errors.includes("Percentage is required.") && offerType === "1" && (
    <div className="error">Percentage is required.</div>
  )} */}
                            </div>
                           
                          {discountType === "2" && (
                          <div className="product_discount">
  <a href="#" onClick={(e) => { e.preventDefault(); handleAddRow(); }}>
    + Add Product
  </a>
  <table id="SelectBoxContainer">
    <tbody>
      {rows.map((row, index) => (
        <tr key={row.id}>
          <td>
            <select
              name={`product_type[${index}]`}
              value={row.productType}
              onChange={(e) => handleProductTypeChange(row.id, e.target.value)}
            >
              <option value="">-Select-</option>
              {productCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </td>
          <td>
            <select
              name={`selected_plist[${index}][]`}
              multiple
              value={row.selectedProducts}
              onChange={(e) =>
                handleSelectedProductsChange(row.id, e.target.options)
              }
            >
              <option value="ALL">All</option>
            {Object.entries(
              productCategories.find((cat) => cat.id === Number(row.productType))
                ?.products || {}
            ).map(([key, value]) => (
              <option key={key} value={key}>
                {value}
              </option>
            ))}
            </select>
          </td>
          <td>
            {rows.length > 1 && (
              <button type="button" onClick={() => handleRemoveRow(row.id)}>
                Remove
              </button>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

           
                )}
                <div>
        
                <label>
                    Discount Status  <span className="form-required">*</span>
                </label>
                <select
                    id="discount_status"
                    name="discount_status"
                    value={formData.discount_status}
                    onChange={handleChange}
                >
                    <option value="1">Active</option>
                    <option value="2">Disabled</option>
                    <option value="3">Archive</option>        
                </select>
            </div>
            <div className="discount-hr">
              <hr/>
            </div>
            <div>
      <label>Coupon Condition</label>
      <div  style={{ marginBottom: "10px" }}>
        <button className="form-submit" type="button" onClick={() => {setShowNew(true);setShowExist(false)}}>
          Add New Coupon
        </button>&nbsp;&nbsp;
        <button className="form-submit" type="button" onClick={() => {setShowNew(false);setShowExist(true)}}>
          Add Existing Coupon
        </button>
      </div>

      {showNew && (
        <div>
          <label>Add New Coupon</label>
          <input type="text" name="neww_coupon" id="neww_coupon" value={formData.neww_coupon} onChange={handleChange}/>
        </div>
      )}
      {showExist && (
         <div className="existing-coupon-wrapper"
  style={{
    position: "relative", 
    marginTop: "20px",
  }}
>
          <label>Add Existing Coupon</label>
          {/* <input
            type="text"
            name="existing_coupon"
            id="existing_coupon"
            value={existingInput}
            onChange={handleExistingInput}
            autoComplete="off"
          />
          <input type="hidden" name="existing_name" id="existing_name" />
          {existingInput && filteredCoupons.length > 0 && (
            <ul className="existing-coupons">
              {filteredCoupons.map((coupon, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setExistingInput(coupon);
                    setFilteredCoupons([]);
                  }}
                  style={{ cursor: "pointer", padding: "2px 0" }}
                >
                  {coupon}
                </li>
              ))}
            </ul>
          )} */}
           <Autocomplete
                id="existing_coupon"
                disablePortal
                options={options}
                sx={{ 
                    width: "50%", 
                    backgroundColor:"#fff",
                    border: "1px solid #ccc",
                    // maxHeight: "20px" 
                   display: "block"
                  
                }}
                renderOption={renderOption}
                getOptionLabel={getOptionLabel}
                onChange={onChange}
                value={selectedCoupon}
                inputValue={searchValue}
                onInputChange={(event, newInputValue) => setSearchValue(newInputValue)}
                renderInput={(params) => (
                    <TextField {...params} />
                )}
                  slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: "preventOverflow",
                        enabled: false, 
                      },
                    ],
                  },
                }}
            />
        </div>
      )}
    </div>
                        
                           <input type="submit" value="Save Discount" className="form-submit"  />
                            </form>
                        </div>

                    </div>
                    <div className="right">
                        <SalespersonSidebar/>
                    </div>
                    </div>
                    )}
                    </>
    );
};

export default CreateNewDiscount;